export default {
  primary: '#1B9CFC',
  disabled: '#B7B7B7',
  font: '#3b364e'
};



// WEBPACK FOOTER //
// ./src/utils/colors.js